<template>
  <mf-card-container style="height: 100%" title="Disparos" :description="filteredCardDescription">
    <v-data-table v-if="hasData" :items="customerBillingData" :headers="headers" :loading="loading" hide-default-footer disable-pagination>
      <template v-slot:item="{ item, index }">
        <tr>
          <td>
            <div class="channel-icon-container">
              <mf-icon fill small color="marca-0-l10">{{ item.icon }}</mf-icon>
              {{ item.canal }}
            </div>
          </td>
          <td>
            {{ item.clientes.toLocaleString('pt-BR') }}
            <mf-quick-actions
              v-show="chosenCustomerType === 'received_and_bought'"
              v-if="quickActionsProps('received_and_bought')[index]"
              :key="`${item.canal}-${index}-received_and_bought`"
              v-bind="quickActionsProps('received_and_bought')[index]"
            />
            <mf-quick-actions
              v-show="chosenCustomerType === 'received_and_bought_with_offer_products'"
              v-if="quickActionsProps('received_and_bought_with_offer_products')[index]"
              :key="`${item.canal}-${index}-received_and_bought_with_offer_products'`"
              v-bind="quickActionsProps('received_and_bought_with_offer_products')[index]"
            />
            <mf-quick-actions
              v-show="chosenCustomerType === 'received_and_bought_with_received_product'"
              v-if="quickActionsProps('received_and_bought_with_received_product')[index]"
              :key="`${item.canal}-${index}-received_and_bought_with_received_product`"
              v-bind="quickActionsProps('received_and_bought_with_received_product')[index]"
            />
          </td>
          <td>{{ item.distribuicao }}%</td>
          <td>{{ locale(item.faturamento, 2) | localeString(2) | currency }}</td>
          <td>
            {{ locale(item.ticket, 2) | localeString(2) | currency }}
          </td>
          <td>
            {{ item.cupons.toLocaleString('pt-BR') }}
          </td>
        </tr>
      </template>
    </v-data-table>
    <empty-chart v-else />
  </mf-card-container>
</template>

<script>
import { localeString } from '@/config/helpers.js'
import EmptyChart from '@/modules/mobile/desempenho/views/components/EmptyChart'
import {
  criteriaGroup,
  campaignReceivedAndPurchasedOnFixedPeriodAtUnitsCriteria,
  campaignReceivedAndPurchasedOfferProductAtUnitsCriteria,
  campaignReceivedAndPurchasedVariableProductCampaign,
} from '@/components/quick-actions/segmentationGroups.js'
import { mariaResults } from '@/modules/maria/campanha-da-maria-v2/mixins/maria-results'
import { filteredCardDescription } from '@/modules/maria/campanha-da-maria-v2/mixins/filtered-card-description'
export default {
  name: 'CustomerBillingTriggers',

  components: {
    EmptyChart,
  },

  mixins: [mariaResults, filteredCardDescription],

  props: {
    metrics: {
      type: Object,
      required: true,
    },
    chosenCustomerType: {
      type: String,
      required: true,
    },
    dateCriteriaFilter: {
      type: Object,
      default: () => {},
    },
    channels: {
      type: Array,
      default: () => [],
    },
    units: {
      type: Array,
      default: () => [],
    },
    unitsConfiguration: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    locale: localeString,
  }),

  computed: {
    headers() {
      return [
        {
          text: 'Canal',
          value: 'canal',
          width: '14%',
          sortable: false,
        },
        {
          text: 'Clientes convertidos',
          value: 'clientes',
          width: '14%',
          sortable: false,
        },
        {
          text: 'Distribuição',
          value: 'distribuicao',
          width: '15%',
          sortable: false,
        },
        {
          text: 'Faturamento',
          value: 'faturamento',
          width: '17%',
          sortable: false,
        },
        {
          text: 'Ticket médio',
          value: 'ticket',
          width: '15%',
          sortable: false,
        },
        {
          text: 'Cupons',
          value: 'cupons',
          width: '15%',
          sortable: false,
        },
      ]
    },
    hasData() {
      return this.customerBillingData
        .map((el) => el.clientes + el.cupons + el.faturamento + el.distribuicao + el.ticket)
        .reduce((total, valor) => total + valor, 0)
    },
    totalChannelMessages() {
      const channels = this.metrics.general_metrics?.channels
      return (
        channels?.sms[this.chosenCustomerType].messages +
        channels?.whatsapp[this.chosenCustomerType].messages +
        channels?.email[this.chosenCustomerType].messages +
        channels?.push[this.chosenCustomerType].messages
      )
    },
    customerBillingData() {
      return [
        ...(!this.isChannelActivated('sms')
          ? []
          : [
              {
                canal: 'SMS',
                clientes: this.metrics.clients_metrics?.channels?.sms[this.chosenCustomerType].count,
                distribuicao: parseInt((this.metrics.general_metrics?.channels?.sms[this.chosenCustomerType].messages / this.totalChannelMessages) * 100),
                faturamento: this.metrics.clients_metrics?.channels?.sms[this.chosenCustomerType].revenue,
                ticket: this.metrics.clients_metrics?.channels?.sms[this.chosenCustomerType].average_ticket,
                cupons: this.metrics.clients_metrics?.channels?.sms[this.chosenCustomerType].tickets,
                icon: 'comment',
              },
            ]),
        ...(!this.isChannelActivated('whatsapp')
          ? []
          : [
              {
                canal: 'Whatsapp',
                clientes: this.metrics.clients_metrics?.channels?.whatsapp[this.chosenCustomerType].count,
                distribuicao: parseInt((this.metrics.general_metrics?.channels?.whatsapp[this.chosenCustomerType].messages / this.totalChannelMessages) * 100),
                faturamento: this.metrics.clients_metrics?.channels?.whatsapp[this.chosenCustomerType].revenue,
                ticket: this.metrics.clients_metrics?.channels?.whatsapp[this.chosenCustomerType].average_ticket,
                cupons: this.metrics.clients_metrics?.channels?.whatsapp[this.chosenCustomerType].tickets,
                icon: 'whatsapp',
              },
            ]),
        ...(!this.isChannelActivated('email')
          ? []
          : [
              {
                canal: 'E-mail',
                clientes: this.metrics.clients_metrics?.channels?.email[this.chosenCustomerType].count,
                distribuicao: parseInt((this.metrics.general_metrics?.channels?.email[this.chosenCustomerType].messages / this.totalChannelMessages) * 100),
                faturamento: this.metrics.clients_metrics?.channels?.email[this.chosenCustomerType].revenue,
                ticket: this.metrics.clients_metrics?.channels?.email[this.chosenCustomerType].average_ticket,
                cupons: this.metrics.clients_metrics?.channels?.email[this.chosenCustomerType].tickets,
                icon: 'mail',
              },
            ]),
        ...(!this.isChannelActivated('push')
          ? []
          : [
              {
                canal: 'Push aplicativo',
                clientes: this.metrics.clients_metrics?.channels?.push[this.chosenCustomerType].count,
                distribuicao: parseInt((this.metrics.general_metrics?.channels?.push[this.chosenCustomerType].messages / this.totalChannelMessages) * 100),
                faturamento: this.metrics.clients_metrics?.channels?.push[this.chosenCustomerType].revenue,
                ticket: this.metrics.clients_metrics?.channels?.push[this.chosenCustomerType].average_ticket,
                cupons: this.metrics.clients_metrics?.channels?.push[this.chosenCustomerType].tickets,
                icon: 'phone_iphone',
              },
            ]),
      ]
    },
  },

  methods: {
    quickActionsProps(chosenCustomerType) {
      let label = ''
      if (chosenCustomerType === 'received_and_bought') label = `compraram na ${this.campaign.title}`
      if (chosenCustomerType === 'received_and_bought_with_offer_products')
        label = `receberam e compraram produtos da oferta na campanha ${this.campaign.title}`
      if (chosenCustomerType === 'received_and_bought_with_received_product')
        label = `receberam e compraram o produto que receberam via variável na mensagem da campanha ${this.campaign.title}`

      return [
        ...(!this.isChannelActivated('sms')
          ? []
          : [
              {
                key: `clients-${chosenCustomerType}-products-sms`,
                quickActionGroupId: `clients-${chosenCustomerType}-products-sms`,
                shortDescription: 'Clientes que receberam campanhas SMS',
                longDescription: `Clientes que receberam disparo SMS e ${label}`,
                segmentationGroup: () => criteriaGroup(this.getCriteriaByChannel('SMS', chosenCustomerType)),
              },
            ]),
        ...(!this.isChannelActivated('whatsapp')
          ? []
          : [
              {
                key: `clients-${chosenCustomerType}-products-whatsapp`,
                quickActionGroupId: `clients-${chosenCustomerType}-products-whatsapp`,
                shortDescription: 'Clientes que receberam campanhas Whatsapp',
                longDescription: `Clientes que receberam disparo Whatsapp e ${label}`,
                segmentationGroup: () => criteriaGroup(this.getCriteriaByChannel('WHATSAPP', chosenCustomerType)),
              },
            ]),
        ...(!this.isChannelActivated('email')
          ? []
          : [
              {
                key: `clients-${chosenCustomerType}-products-email`,
                quickActionGroupId: `clients-${chosenCustomerType}-products-email`,
                shortDescription: 'Clientes que receberam campanhas E-mail',
                longDescription: `Clientes que receberam disparo E-mail e ${label}`,
                segmentationGroup: () => criteriaGroup(this.getCriteriaByChannel('EMAIL', chosenCustomerType)),
              },
            ]),
        ...(!this.isChannelActivated('push')
          ? []
          : [
              {
                key: `clients-${chosenCustomerType}-products-push`,
                quickActionGroupId: `clients-${chosenCustomerType}-products-push`,
                shortDescription: 'Clientes que receberam campanhas Push',
                longDescription: `Clientes que receberam disparo Push e ${label}`,
                segmentationGroup: () => criteriaGroup(this.getCriteriaByChannel('PUSH', chosenCustomerType)),
              },
            ]),
      ]
    },
    getCriteriaByChannel(channel, chosenCustomerType) {
      if (chosenCustomerType === 'received_and_bought') {
        return campaignReceivedAndPurchasedOnFixedPeriodAtUnitsCriteria(
          [this.campaign._id],
          this.dateCriteriaFilter.formattedInitialDate,
          this.dateCriteriaFilter.formattedFinalDate,
          this.unitsConfiguration,
          [channel]
        )
      } else if (chosenCustomerType === 'received_and_bought_with_offer_products') {
        return campaignReceivedAndPurchasedOfferProductAtUnitsCriteria(
          [this.campaign._id],
          this.dateCriteriaFilter.formattedInitialDate,
          this.dateCriteriaFilter.formattedFinalDate,
          this.unitsConfiguration,
          [channel]
        )
      } else {
        return campaignReceivedAndPurchasedVariableProductCampaign(
          [this.campaign._id],
          this.dateCriteriaFilter.formattedInitialDate,
          this.dateCriteriaFilter.formattedFinalDate,
          this.unitsConfiguration,
          [channel]
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.channel-icon-container {
  display: flex;
  align-items: center;
  gap: 6px;
  color: $marca-0-l10;
  font-weight: bold;
}
</style>
